import React from 'react';
import AdminTable from '../../containers/AdminPanel'

const Admin = () => {
    return <AdminTable />;
}

export default Admin;
